var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.697327 30V37C0.697327 49.7025 10.9948 60 23.6973 60H30.6973H37.6973C50.3999 60 60.6973 49.7025 60.6973 37V30V23C60.6973 10.2975 50.3999 0 37.6973 0H30.6973H23.6973C10.9948 0 0.697327 10.2975 0.697327 23V30Z",
    fill: "#FEC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6973 24.3164L28.5978 31.7645C28.7367 31.8447 28.8824 31.9026 29.0307 31.9394V46.3846L16.6174 39.0384C16.0471 38.701 15.6973 38.0875 15.6973 37.4248V24.3164ZM45.6972 24.1172V37.4236C45.6972 38.0863 45.3475 38.6997 44.7772 39.0372L32.3639 46.3834V31.8116C32.3942 31.7965 32.4241 31.7804 32.4538 31.7633L45.6972 24.1172Z",
    fill: "#FEC53D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1025 20.7014C16.2601 20.5024 16.4589 20.3343 16.6908 20.2108L29.8158 13.2201C30.3668 12.9266 31.0277 12.9266 31.5787 13.2201L44.7037 20.2108C44.8824 20.306 45.0416 20.4277 45.1773 20.5697L30.7871 28.8778C30.6925 28.9325 30.6053 28.995 30.5258 29.064C30.4463 28.995 30.359 28.9325 30.2644 28.8778L16.1025 20.7014Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBilled);
export default __webpack_public_path__ + "static/media/totalBilled.4168be45791308c2ce79541fd314fc3f.svg";
export { ForwardRef as ReactComponent };